document.addEventListener('DOMContentLoaded', () => {
  const detallesTab = document.querySelector('.tab-detalles-del-producto');
  if (!detallesTab) return;
  const descLarge = detallesTab.querySelector('#descLarge');
  if (!descLarge) return;
  const hasContent = descLarge.textContent.trim().length > 0;
  if (!hasContent) return;
  const target = document.querySelector(
    '.tab-especificaciones .accordion__content .accordion__text'
  );
  if (!target) return;
  target.innerHTML = '';
  target.appendChild(descLarge);

  // Abrir modal de Loox al hacer clic en triggers personalizados
  document.addEventListener('click', (event) => {
    const reviewTrigger = event.target.closest('.open-review-popup, [data-open-review]');

    if (reviewTrigger) {
      event.preventDefault();

      // Usar la función global de Loox
      if (window.looxWrite && typeof window.looxWrite === 'function') {
        window.looxWrite();
      } else {
        console.warn('window.looxWrite no está disponible');
      }
    }
  });

  // Detectar parámetro ?ref=review en la URL
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('ref') === 'review') {
    setTimeout(() => {
      // Llamar directamente a la función de Loox
      if (window.looxWrite && typeof window.looxWrite === 'function') {
        window.looxWrite();
        // Limpiar el parámetro de la URL
        window.history.replaceState({}, document.title, window.location.pathname);
      } else {
        console.warn('window.looxWrite no está disponible');
      }
    }, 1500);
  }
});
